import { List, getIn } from 'immutable'

/** @return {boolean} */
export const selectWeatherLoading = state => state.weather.get('loading')

/** @return {boolean} */
export const selectWeatherFailedToLoad = state => state.weather.get('failedToLoad')

/** @return {number} */
export const selectCurrentLocationId = state => parseInt(state.weather.get('selected'))

/** @return {string} */
export const selectCurrentLocationName = state => {
  const id = selectCurrentLocationId(state)
  return getIn(state, ['weather', id, 'data', 0, 'locationName'], '')
}

/** @return {Immutable.List} */
export const selectCurrentLocationData = state => {
  const id = selectCurrentLocationId(state)
  return getIn(state, ['weather', id, 'data'], List())
}
